export const Domain = {
  ACCOUNT: "account",
  EBOOK: "ebook",
  READING_PLAN: "reading_plan",
  STUDY: "study",
  VIDEO: "video",
  TRAINING: "training",
  CURRICULUM: "curriculum",
  LICENSE: "license",
  CUSTOMER_LIBRARY: "customer_library",
  DIGITAL_EVENT: "digital_event",
  SYSTEM: "system",
} as const

export type Domain = (typeof Domain)[keyof typeof Domain]

/**
 * Maps the event domain to the interaction name.
 *
 * Why? FullStory limits the number of event types we can create. To work
 * around this, the main event type is mapped from the event domain. An event
 * "sub type" (or name) can be used to determine additional analytical
 * information. Because of this limitation, we've used a similar approach with
 * Intercom.
 */
export function mapAnalyticsDomainToInteractionName(domain: Domain): string {
  switch (domain) {
    case Domain.ACCOUNT:
      return "Account Interaction"
    case Domain.DIGITAL_EVENT:
      return "Digital Event Interaction"
    case Domain.CURRICULUM:
      return "Curriculum Interaction"
    case Domain.CUSTOMER_LIBRARY:
      return "Customer Library Interaction"
    case Domain.READING_PLAN:
      return "Reading Plan Interaction"
    case Domain.EBOOK:
      return "Ebook Interaction"
    case Domain.LICENSE:
      return "License Interaction"
    case Domain.SYSTEM:
      return "System Interaction"
    case Domain.STUDY:
      return "Study Interaction"
    case Domain.TRAINING:
      return "Training Interaction"
    case Domain.VIDEO:
      return "Video Interaction"
    default:
      assertNever(domain)
  }
}

function assertNever(x: never): never {
  throw new Error(`Unexpected domain: ${x}`)
}
